import { render, staticRenderFns } from "./BaseLabel.vue?vue&type=template&id=32fbeb91&scoped=true"
import script from "./BaseLabel.vue?vue&type=script&lang=js"
export * from "./BaseLabel.vue?vue&type=script&lang=js"
import style0 from "./BaseLabel.vue?vue&type=style&index=0&id=32fbeb91&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fbeb91",
  null
  
)

export default component.exports